export default "__VITE_ASSET__Et$9HD4E__"